// extracted by css-extract-rspack-plugin
export default {"cls1":"ErrorStateFeed-cls1_t7N","cls2":"ErrorStateFeed-cls2_4LP ErrorStateFeed-cls1_t7N"};